import React, { useState } from "react"
import { Activity, Eye, Heart, Check2, ChevronDown } from "react-bootstrap-icons"
import img from "../../assets/servicesimg.png"
export default function BenServices() {
  const [openIndex, setOpenIndex] = useState(null)

  const therapies = [
    {
      icon: Activity,
      title: "Cognitive Behavioural Therapy",
      text:
        "A structured approach that helps you notice patterns, build skills, and make lasting changes.",
      tags: ["Anxiety", "Depression", "Stress"]
    },
    {
      icon: Activity,
      title: "Acceptance and Commitment Therapy",
      text:
        "ACT helps people develop psychological flexibility by learning to accept difficult thoughts and feelings while committing to actions that align with their values.",
      tags: ["Values", "Acceptance", "Behaviour change"]
    },
    {
      icon: Eye,
      title: "Mindfulness Based CBT",
      text:
        "A blend of cognitive behavioural therapy and mindfulness practices that helps increase awareness of thoughts and emotions while reducing automatic negative patterns.",
      tags: ["Mindfulness", "Stress", "Emotional awareness"]
    },
    {
      icon: Heart,
      title: "Compassion Focused Therapy",
      text:
        "CFT helps people develop self compassion and reduce shame or self criticism by strengthening the brain systems related to care, safety, and emotional regulation.",
      tags: ["Self compassion", "Shame", "Emotional regulation"]
    },
    {
      icon: Eye,
      title: "EMDR Therapy",
      text:
        "A trauma focused therapy that supports processing difficult experiences and reducing distress.",
      tags: ["Trauma", "PTSD", "Phobias"]
    },
    {
      icon: Heart,
      title: "Schema Therapy",
      text:
        "An integrative approach focused on long term patterns, needs, and relationship themes.",
      tags: ["Self esteem", "Relationships", "Chronic patterns"]
    }
  ]

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section id="services" className="benServicesSection">
      <div className="profile-container">
        <div className="row align-items-center g-4 g-lg-5">
          <div className="col-lg-6">
            <div className="benServicesIntro">
              <div className="benServicesEyebrowWrap">
                <span className="benServicesEyebrowLine"></span>
                <p className="benServicesEyebrow mb-0">HOW I CAN SUPPORT YOU</p>
                <span className="benServicesEyebrowLine"></span>
              </div>

              <h1 className="benServicesHeading">Services</h1>

              <p className="benServicesLead">
                I offer psychological therapy tailored to your individual needs.
              </p>
            </div>

            <div className="benServicesList">
              {therapies.map((t, index) => {
                const Icon = t.icon
                const isOpen = openIndex === index

                return (
                  <div
                    className={`serviceCard ${isOpen ? "serviceCardOpen" : "serviceCardClosed"}`}
                    key={t.title}
                  >
                    <button
                      type="button"
                      className="serviceCardInner w-100 border-0 bg-transparent text-start"
                      onClick={() => handleToggle(index)}
                    >
                      <div className="d-flex align-items-start gap-3">
                        <div className="serviceIcon">
                          <Icon className="serviceIconSvg" />
                        </div>

                        <div className="flex-grow-1">
                          <div className="d-flex align-items-center justify-content-between gap-3">
                            <h3 className="serviceTitle mb-0">{t.title}</h3>

                            <ChevronDown
                              className={`serviceChevron ${isOpen ? "serviceChevronOpen" : ""}`}
                            />
                          </div>

                          {isOpen && (
                            <div className="serviceContent mt-3">
                              <p className="serviceText mb-3">{t.text}</p>

                              <div className="d-flex flex-wrap gap-2">
                                {t.tags.map((tag) => (
                                  <span className="serviceTag" key={tag}>
                                    <Check2 className="serviceTagIcon" />
                                    {tag}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </button>
                  </div>
                )
              })}
            </div>
          </div>

          <div className="col-lg-6">
            <div className="serviceImageWrap">
              <img
                src={img}
                alt="Professional portrait"
                className="img-fluid  serviceImage"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}